import { type ReactElement } from 'react';

function DarkBlueLogo(): ReactElement {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="40" height="40" rx="8" fill="#00006A" />
            <g clipPath="url(#clip0_26_20852)">
                <path
                    d="M19.5775 29H16.763C13.5909 29 11.0195 26.3975 11.0195 23.187V16.0436C11.0195 15.676 11.1609 15.3303 11.4178 15.0703L15.038 11.4031C15.2947 11.1431 15.6362 11 15.9996 11H21.4446C23.5155 11 25.4492 11.8306 26.8898 13.3387C28.3306 14.8472 29.0854 16.8348 29.0152 18.9354C28.9482 20.9361 28.114 22.8037 26.6661 24.1942C25.2278 25.5757 23.3428 26.3365 21.3583 26.3365H20.1384V28.4323C20.1384 28.7458 19.8872 29 19.5775 29ZM12.4201 16.0605V23.1869C12.4201 25.6105 14.3684 27.5823 16.763 27.5823H18.7378V24.9188H21.3583C22.9825 24.9188 24.5251 24.2963 25.702 23.1659C26.8814 22.0332 27.5609 20.5137 27.6153 18.8874C27.6726 17.1743 27.0573 15.5537 25.8827 14.324C24.7085 13.0947 23.1323 12.4177 21.4446 12.4177H16.0165L12.4201 16.0605Z"
                    fill="#1E96FF"
                />
                <path
                    d="M20.1139 26.3362H17.4605C15.4699 26.3362 13.8506 24.6971 13.8506 22.6826V13.8928H21.0883C23.6942 13.8928 25.814 16.0385 25.814 18.6757C25.814 21.3129 23.694 23.4585 21.0883 23.4585H20.1139V26.3363V26.3362ZM15.251 15.3104V22.6827C15.251 23.9177 16.2402 24.9188 17.4604 24.9188H18.7131V23.2852C18.7131 22.5981 19.2636 22.0411 19.9424 22.0411H21.0457C22.8763 22.0411 24.3952 20.5617 24.413 18.7089C24.4309 16.8382 22.9324 15.3105 21.0881 15.3105H15.2509L15.251 15.3104Z"
                    fill="#1E96FF"
                />
            </g>
            <defs>
                <clipPath id="clip0_26_20852">
                    <rect width="18" height="18" fill="white" transform="translate(11.0195 11)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default DarkBlueLogo;
